import { GiHamburgerMenu } from "react-icons/gi";
import * as React from "react";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import { Link, useNavigate } from "react-router-dom";
import { AppContext } from "../Context/Context";
// import Box from "@mui/material/Box";
// import List from "@mui/material/List";
// import ListItem from "@mui/material/ListItem";
// import ListItemButton from "@mui/material/ListItemButton";
// import ListItemIcon from "@mui/material/ListItemIcon";
// import ListItemText from "@mui/material/ListItemText";
// import Accordion from "@mui/material/Accordion";
// import AccordionSummary from "@mui/material/AccordionSummary";
// import AccordionDetails from "@mui/material/AccordionDetails";
// import Typography from "@mui/material/Typography";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import logout from "./map/icons/logout.svg";

export default function SideNavbar() {
  const [open, setOpen] = React.useState(false);
  const navigate = useNavigate();
  const { user, setUser } = React.useContext(AppContext)

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  const handleLogout = () => {
    localStorage.removeItem("userInfo");
    setUser(() => null);
    navigate("/login");
  };

  const DrawerList = (
      <div
          className="bg-blue-900 h-full text-white text-xs w-60  "
          role="presentation"
          onClick={() => toggleDrawer(false)}
      >
        <ul className="list-none p-0 ">
          <li className="hover:bg-white hover:text-black">
            <Link to="/">
              <div className="px-4 py-2">
                <span className="text-lg">Statistics</span>
              </div>
            </Link>
          </li>
          <li className="hover:bg-white hover:text-black">
            <Link to="/dashboard">
              <div className="px-4 py-2">
                <span className="text-lg">Dashboard</span>
              </div>
            </Link>
          </li>
          { user?.isAdmin && (
              <li className="hover:bg-white hover:text-black">
                <Link to="/manage-users">
                  <div className="px-4 py-2">
                    <span className="text-lg">Manage Users</span>
                  </div>
                </Link>
              </li>
          )}
          {/* <li className="hover:bg-white hover:text-black">
          <Link to="/manage-clients">
            <div className="px-4 py-2">
              <span className="text-lg">Manage Clients</span>
            </div>
          </Link>
        </li>
        <li className="cursor-not-allowed">
          <div className="px-4 py-2">
            <span className="text-lg cursor-not-allowed">
              View User Activity Logs
            </span>
          </div>
        </li>
        <li className="cursor-not-allowed bg-blue-900">
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1-content"
              id="panel1-header"
            >
              <Typography>Client Configuration</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <li className="mt-1  p-0 border border-teal-800 ">
                <div className="px-4 py-2">
                  <span className="text-xs pl-3 cursor-not-allowed ">
                    - Location
                  </span>
                </div>
              </li>
              <Link to="/infestation">
                <li className=" mt-1 p-0 border border-teal-800 ">
                  <div className="px-4 py-2">
                    <span className="text-xs pl-3  ">
                      - Infestation
                    </span>
                  </div>
                </li>
              </Link>
              <Link to="/product">
                <li className="mt-1  p-0 border border-teal-800 ">
                  <div className="px-4 py-2">
                    <span className="text-xs pl-3  ">
                      - Product Recommendation
                    </span>
                  </div>
                </li>
              </Link>
              <li className="mt-1  p-0 border border-teal-800 ">
                <div className="px-4 py-2">
                  <span className="text-xs pl-3 cursor-not-allowed ">
                    - View My API limit
                  </span>
                </div>
              </li>
            </AccordionDetails>
          </Accordion>
        </li> */}
          <li className="hover:bg-white hover:text-black bg-blue-800">
            <div className="px-4 py-2" onClick={handleLogout}>
              <span className="text-lg">Logout</span>
              {/* <img src={logout} alt="logout" /> */}

            </div>
          </li>
        </ul>
      </div>
  );

  return (
      <div>
        <Button onClick={toggleDrawer(true)}>
          <GiHamburgerMenu color="#1e293b" size={24} />{" "}
        </Button>
        <Drawer open={open} onClose={toggleDrawer(false)}>
          {DrawerList}
        </Drawer>
      </div>
  );
}
